/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */
import {getLang} from "./main.js";
import {isSourceMode} from "./grid.js";
import {setTemplateLoaderVisibility} from "./template.js";

let previewSize = null;
let previewSizes = {
    'small-mobile': 575,
    'mobile': 767,
    'tablet': 992,
    'laptop': 1200,
    'desktop': 1400,
    'large-desktop': 1920,
};

function preview(url) {
    if (window.ddcontentpreview && !window.ddcontentpreview.closed) {
        window.ddcontentpreview.location.href = url;
        window.ddcontentpreview.focus();
    } else {
        let width = previewSizes[previewSize] ? previewSizes[previewSize] : screen.width * 0.8;
        window.ddcontentpreview = window.open(url, '_blank', 'scrollbars=1, width=' + width + ', height=' + (screen.height * 0.8));
    }
}

export function registerPreviewEvents() {
    let previewSelection = document.querySelectorAll('.preview .preview-selection');
    if (previewSelection) {
        previewSelection.forEach(el => {
            el.addEventListener('click', function (e) {
                setTemplateLoaderVisibility(true);
                let formEl = document.querySelector('#previewModal').getAttribute('data-target');
                let form = document.querySelector('form' + formEl);

                previewSize = el.getAttribute('data-value');

                let data = $(form).serialize();
                if (isSourceMode()) {
                    data += '&source=' + encodeURIComponent($('.dd-veditor-source textarea').val());
                } else {
                    $.each(window.VisualEditorInstance.serialize(), function () {
                        data += '&widget[' + this.row + '][' + this.col + ']=' + encodeURIComponent(JSON.stringify(this));
                    });
                }
                data += '&editlanguage=' + getLang();

                $.post($(form).attr('action'), data, function (data) {
                    if (data.error || !data.url) {
                        ddh.alert(data.msg);
                        return;
                    }

                    preview(data.url);
                    setTemplateLoaderVisibility(false);
                });

                $('#previewModal').modal('hide');
            });
        })
    }
}
